import React, { Component } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { change } from 'redux-form'
import Rodal from 'rodal'
import Tour from '../../../components/renderPropComponents/Tour'
import selectors from '../../../store/shared/selectors'
import BlankCard from '../../../components/ui/cards/BlankCard'
import AmortizationSliderForm from './components/AmortizationSliderForm'
import CollegeTuitionSearchResults from './components/CollegeTuitionSearchResults'
import DeepDiveResultsWrapper from './components/DeepDiveResultsWrapper'
import CollegeAndTuitionForm from './components/CollegeAndTuitionForm'
import amortization from '../../../utils/amortization'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'
import * as savedTuitionSearchesDuck from './savedTuitionSearchesDuck'
import * as tuitionDuck from './tuitionDuck'
import PageTitle from '../../../components/ui/typography/PageTitle'
import withTour from '../../../components/hocs/withTour'
import intercom from '../../../utils/intercom/intercomUtils'
import SearchHistoryPanel from '../../../components/ui/SearchHistory/SearchHistoryPanel/SearchHistoryPanel'
import SavedTuitionSearchesWrapper from './components/SavedTuitionSearches/SavedTuitionSearchesWrapper'
import withTuition from '../../../utils/graphql/hocs/withTuition'

class AuthenticatedTuitionIndex extends Component {
  static propTypes = {
    amortizationFormValues: PropTypes.any.isRequired,
    performDeleteSavedTuitionSearch: PropTypes.func.isRequired,
    performRetrieveSavedTuitionSearches: PropTypes.func.isRequired,
    performSaveTuitionSearch: PropTypes.func.isRequired,
    queryParams: PropTypes.any.isRequired,
    savedTuitionSearches: PropTypes.array,
    collegeAndTuitionFormValues: PropTypes.any.isRequired,
    universityData: PropTypes.any.isRequired,
    isLessThanMedium: PropTypes.any.isRequired,
    change: PropTypes.func.isRequired,
    userId: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this._isMounted = false

    this.state = {
      chartData: null,
      showSalaryFields: false,
      runTour: false,
      isShowingModal: false,
      jobTitle: '',
    }

    this.updateState = updates => this.setState(updates)

    this.onChangeUniversity = value => {
      this.props.getTuitionData(Object.assign({}, { university: value }))
    }

    this.handleFormChanges = () => {
      const { rate, term } = this.props.amortizationFormValues
      const {
        amount,
        startingSalaryWithoutDegree,
        startingSalaryWithDegree,
      } = this.props.collegeAndTuitionFormValues
      const amortizationResult = amortization.amortize(
        parseFloat(
          String(amount)
            .replace(/$/g, '')
            .replace(/,/g, ''),
        ),
        parseInt(term, 10),
        parseFloat(rate / 100),
      )

      const chartData = amortization.formatAmortizationChartData(
        amortizationResult,
        startingSalaryWithDegree,
        startingSalaryWithoutDegree,
      )
      this.updateState({ chartData })
    }

    this.saveTuitionSearch = () => {
      this.props
        .performSaveTuitionSearch({
          searchParams: Object.assign(
            {},
            this.props.collegeAndTuitionFormValues,
            this.props.amortizationFormValues,
          ),
        })
        .then(() => {
          notificationsUtils.showSuccessNotification('Saved Results Successfully!')
          this.props.performRetrieveSavedTuitionSearches({
            user_id: this.props.userId,
          })
        })
    }

    this.onVirtualTourOpen = () => {
      const { universityData } = this.props
      this.updateState({ isShowingModal: true })
      this.univeristyTour.src = universityData.tour
    }

    this.onVirtualTourClose = () => {
      this.updateState({ isShowingModal: false })
      this.univeristyTour.src = null
    }

    this.onSalarySearch = jobTitle => {
      this.props.getSalaryByJobTitle({ jobTitle })
      this.setState({ jobTitle })
    }
  }

  componentWillMount() {
    const { performRetrieveSavedTuitionSearches, userId } = this.props
    performRetrieveSavedTuitionSearches({ user_id: userId })
  }

  componentDidMount() {
    this._isMounted = true
    setTimeout(() => {
      this.handleFormChanges()
      const { university } = this.props.queryParams
      if (university) {
        this.props.change('collegeAndTuitionForm', 'university', university)
        this.onChangeUniversity(university)
      }
    })
    setTimeout(() => {
      if (this._isMounted) this.updateState({ runTour: true })
    }, 2000)
    intercom.intercomUpdate({
      user_id: this.props.userId,
    })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(this.props.collegeAndTuitionFormValues, prevProps.collegeAndTuitionFormValues) ||
      !isEqual(this.props.amortizationFormValues, prevProps.amortizationFormValues)
    ) {
      this.handleFormChanges()
    }

    if (this.props.salaryByJobTitle !== prevProps.salaryByJobTitle) {
      this.props.setStartingSalaryWithDegree(this.props.salaryByJobTitle)
    }
  }

  render() {
    const { chartData, showSalaryFields, jobTitle } = this.state
    const {
      universityData,
      queryParams,
      collegeAndTuitionFormValues,
      salaryByJobTitle,
      isLessThanMedium,
      savedTuitionSearches,
      performDeleteSavedTuitionSearch,
      loadingTuitionData,
    } = this.props
    const { isShowingModal, runTour } = this.state

    return (
      <div>
        <div className="main-page">
          <PageTitle
            content="How much will your education really cost?"
            showHistoryBtn={false}
            tourName="tuition"
          />
          <Rodal
            visible={isShowingModal}
            measure="%"
            width={90}
            height={70}
            customMaskStyles={{
              opacity: 0.8,
              backgroundColor: 'black',
            }}
            closeOnEsc
            onClose={() => this.onVirtualTourClose()}
            duration={200}
          >
            <embed
              ref={input => {
                this.univeristyTour = input
              }}
              type=""
              style={{ height: '100%', width: '100%' }}
            />
          </Rodal>
          <div className="row">
            <div className="col-sm-4 pr-0">
              <div id="collegeSearch">
                <div className="card shadow">
                  <div className="card-body">
                    <h6 style={{ marginBottom: 10 }}>College Search</h6>
                    <div className="text-center">
                      {universityData.tour && (
                        <button
                          className="btn btn-link p-0"
                          onClick={() => this.onVirtualTourOpen()}
                        >
                          <i className="fal fa-eye" />
                          &nbsp; Virtual Tour
                        </button>
                      )}
                    </div>
                    <CollegeAndTuitionForm
                      showSalaryFields={showSalaryFields}
                      onChange={this.handleFormChanges}
                      onChangeUniversity={this.onChangeUniversity}
                      initialValues={Object.assign(
                        {},
                        {
                          amount:
                            universityData && universityData.inStateTuition
                              ? universityData.inStateTuition
                              : '36000',
                          startingSalaryWithDegree: salaryByJobTitle ? salaryByJobTitle : '50000',
                          startingSalaryWithoutDegree: '35000',
                          university: collegeAndTuitionFormValues.university,
                          salarySearch: jobTitle ? jobTitle : '',
                        },
                        queryParams,
                      )}
                      onSalarySearch={this.onSalarySearch}
                      isPerformingSearch={loadingTuitionData}
                    />
                  </div>
                </div>
              </div>
              <div id="terms">
                <BlankCard delay={1} title="Student Loan Terms">
                  <AmortizationSliderForm
                    onChange={this.handleFormChanges}
                    initialValues={Object.assign({}, { rate: 6, term: 15 }, queryParams)}
                  />
                </BlankCard>
              </div>
              <BlankCard notCard delay={1.8}>
                <button
                  disabled={!collegeAndTuitionFormValues.university}
                  className="btn btn-block btn-primary shadow"
                  onClick={this.saveTuitionSearch}
                  style={{ marginTop: 10 }}
                  id="saveTuition"
                  hidden
                >
                  Save Search
                </button>
              </BlankCard>

              {!showSalaryFields && universityData.instName && !isLessThanMedium && (
                <BlankCard delay={this._isMounted ? 0 : 2.0} style={{ marginTop: 10 }}>
                  <CollegeTuitionSearchResults data={universityData} />
                </BlankCard>
              )}
            </div>
            <div className="col-sm-8">
              <div id="deepDive">
                <BlankCard notCard delay={1.6}>
                  <DeepDiveResultsWrapper
                    chartData={chartData}
                    onToggleTab={nextShowSalaryFields =>
                      this.updateState({
                        showSalaryFields: nextShowSalaryFields,
                      })
                    }
                    salaryWithDegree={collegeAndTuitionFormValues.startingSalaryWithDegree}
                    salaryWithoutDegree={collegeAndTuitionFormValues.startingSalaryWithoutDegree}
                    updateChartsData={this.handleFormChanges}
                  />
                </BlankCard>
              </div>
            </div>
          </div>
          <SearchHistoryPanel searchFilter="Tuition">
            <SavedTuitionSearchesWrapper
              tuitionSearches={savedTuitionSearches}
              onDelete={performDeleteSavedTuitionSearch}
            />
          </SearchHistoryPanel>
        </div>
        <Tour
          tourSteps={tourSteps}
          runTour={false && runTour}
          onRequestClose={() => this.updateState({ runTour: false })}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getFormValues = selectors.makeGetFormValues()
  return state => ({
    amortizationFormValues: getFormValues(state.form.amortizationSliderForm),
    collegeAndTuitionFormValues: getFormValues(state.form.collegeAndTuitionForm),
    queryParams: selectors.getQueryStringSimply(state),
    isLessThanMedium: selectors.isLessThanMedium(state),
    savedTuitionSearches: savedTuitionSearchesDuck.getSavedTuitionSearches(state),
    userId: selectors.getUserId(state),
  })
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performDeleteSavedTuitionSearch: savedTuitionSearchesDuck.performDeleteSavedTuitionSearch,
      performRetrieveSavedTuitionSearches:
        savedTuitionSearchesDuck.performRetrieveSavedTuitionSearches,
      performSaveTuitionSearch: savedTuitionSearchesDuck.performSaveTuitionSearch,
      setStartingSalaryWithDegree: tuitionDuck.setStartingSalaryWithDegree,
      change,
    },
    dispatch,
  )

const tourSteps = [
  {
    selector: '#collegeSearch',
    content: "First, select any college you'd like to attend.",
  },
  {
    selector: '#amount',
    content: 'You can adjust the total amount of your loan here.',
  },
  {
    selector: '#terms',
    content: 'Adjust your loan terms to see how small changes can affect your future.',
  },
  {
    selector: '#deepDive',
    content: 'View detailed results of your analysis here.',
  },
  {
    selector: '#breakeven',
    content: "And don't forget about the Breakeven Analysis!",
  },
]

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(withTour('tuition', tourSteps)(withTuition(AuthenticatedTuitionIndex)))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/AuthenticatedTuitionIndex.js